/* es-home — easysea 2026-08: tracking dei click della home (dataLayer, GTM esistente). Niente altro. */
(function () {
  'use strict';
  function push(name, data) { try { window.dataLayer = window.dataLayer || []; var p = { event: name, device: window.matchMedia('(max-width: 999px)').matches ? 'mobile' : 'desktop' }; for (var k in data) if (data[k] != null) p[k] = data[k]; window.dataLayer.push(p); } catch (e) { } }
  push('homepage_view', { page_path: location.pathname });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a'); if (!a) return;
    var t = a.closest('[data-es-track]');
    if (t && t.dataset.esTrack === 'category_click') { push('category_click', { area: t.dataset.esArea, source: 'home' }); return; }
    if (t && t.dataset.esTrack === 'hero_cta') { push('hero_cta_click', { family: t.dataset.esFamily }); return; }
    var card = a.closest('product-card'); var sec = a.closest('[data-es-family]');
    if (card && sec) {
      var li = card.closest('li'); var pos = li ? Array.prototype.indexOf.call(li.parentNode.children, li) + 1 : null;
      push(sec.dataset.esFamily + '_product_click', { product_handle: card.getAttribute('handle'), position: pos });
    }
  }, { passive: true });
})();
